import { YtaApiClient } from '@alexanderathoodly/data-models'

export const apiClient = new YtaApiClient({
	staging: import.meta.env.MODE !== 'production',
})
